/* Kurotsuki product page: gallery, buy box, annotated knife, specs and "bekijk ook" carousel.
   Prices, availability and variant id come from Shopify (window.KT_PRODUCT / window.KT_PRODUCTS);
   photos, short texts and the annotation data come from kurotsuki-products.js. */
(function(){
  const root = document.getElementById("pdp");
  if(!root || !window.KT_PRODUCT) return;

  const sp = window.KT_PRODUCT;
  const localId = KT_HANDLE_MAP[sp.handle];
  const local = getProductById(localId) || {};
  const status = sp.status;                            // available | soldout | soon
  const notBuyable = status !== "available";

  const ssr = document.getElementById("pdp-ssr"); if(ssr) ssr.remove();
  const gallery = sp.images || [];          // only the photos that are on the Shopify product
  const escT = (t) => String(t == null ? "" : t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  // every photo gets its own alt text; the first one loads with priority, the others lazily
  const imgTag = (src, i = 0, eager = false) => `<img src="${src}" alt="${sp.title}, foto ${i + 1} van ${gallery.length || 1}" class="${/\.png(\?|$)/.test(src) ? "" : "fit-cover"}"${eager ? ' fetchpriority="high" decoding="async"' : ' loading="lazy" decoding="async"'} />`;
  const mainMedia = (i) => gallery.length ? imgTag(gallery[i], i, i === 0) : "";


  // "Lead: text" -> the first words in bold, so the list can be scanned
  const leadBold = (f) => { const i = String(f).indexOf(": "); return i > 0 && i < 32 ? `<strong>${f.slice(0, i + 1)}</strong>${f.slice(i + 1)}` : f; };

  // one quiet line under the buy button, and the same facts in a collapsible block lower down
  const microHTML = () => {
    const thin = (d) => `<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
    const ic = {
      truck: thin('<path d="M2.5 6.5h10v9h-10z"/><path d="M12.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/>'),
      back: thin('<path d="M4 12a8 8 0 1 0 2.6-5.9"/><path d="M4 4.5v4h4"/>'),
      shield: thin('<path d="M12 3l7 2.7v5.6c0 4.3-2.9 7.7-7 9.7-4.1-2-7-5.4-7-9.7V5.7L12 3z"/><path d="M8.8 12l2.2 2.2 4.2-4.4"/>')
    };
    const parts = ((sp.preorder ? sp.microPreorder : sp.micro) || "").split("\u00b7").map(x => x.trim()).filter(Boolean);
    const del = parts.find(x => /verzond|levertijd|pre-order|bezorg/i.test(x));
    const ret = parts.find(x => /bedenk|retour/i.test(x));
    const war = parts.find(x => /garantie/i.test(x));
    const ff = ((window.KT_CFG && window.KT_CFG.freeFrom) || 7500) / 100;
    const freeFrom = "\u20ac " + (ff % 1 ? ff.toFixed(2).replace(".", ",") : ff);
    // "14 dagen bedenktijd" -> big "14 dagen", small "bedenktijd"
    const split = (t) => { const m = /^(\d+\s+\S+)\s+(.*)$/.exec(t || ""); return m ? [m[1], m[2]] : [t || "", ""]; };
    const boxes = [
      sp.preorder ? [ic.truck, "Pre-order", (del || "").replace(/^pre-order:?\s*/i, "")] : [ic.truck, "Gratis verzending", "vanaf " + freeFrom],
      ret ? [ic.back].concat(split(ret)) : null,
      war ? [ic.shield].concat(split(war)) : null
    ].filter(Boolean);
    return `<div class="pdp-assure2"><div class="pdp-pay-slot" id="pdp-pay-slot"></div><ul class="pdp-boxes">${boxes.map(x => `<li><span class="pdp-box-ic">${x[0]}</span><strong>${escT(x[1])}</strong>${x[2] ? `<span>${escT(x[2])}</span>` : ""}</li>`).join("")}</ul></div>`;
  };
  const infoAccHTML = () => {
    const I = sp.info || {};
    const items = [
      ["Levering", [sp.preorder ? sp.preorderText : "", I.delivery, I.shipping].filter(Boolean)],
      ["Garantie", [I.warranty].filter(Boolean)],
      ["Retourneren", [I.returns].filter(Boolean)]
    ].filter(x => x[1].length);
    if(!items.length || notBuyable) return "";
    const care = "Was het mes met de hand in warm water, droog het direct af en zet het regelmatig aan over een slijpsteen of keramische staaf. Niet in de vaatwasser.";
    return `<div class="pdp-acc"><details><summary>Onderhoud</summary><div><p>${escT(care)}</p></div></details>${items.map((x, n) => `<details><summary>${x[0]}</summary><div>${x[1].map(p => `<p>${escT(p)}</p>`).join("")}</div></details>`).join("")}</div>`;
  };

  // set: what is in the box, one small card per knife (photo, name, key facts, link)
  const setItemsHTML = () => {
    if(!local.setItems || notBuyable) return "";
    const all = window.KT_PRODUCTS || [];
    const cards = local.setItems.map(it => {
      const o = all.find(x => x.handle === it.handle);
      if(!o) return "";
      return `<a class="pdp-inset-card" href="${o.url}">
        ${o.image ? `<span class="pdp-inset-img"><img src="${o.image}" alt="${o.title}" loading="lazy" /></span>` : ""}
        <span class="pdp-inset-body"><strong>${o.title}</strong><span class="pdp-inset-specs">${it.specs.map(x => `<span>${x}</span>`).join("")}</span><em>Bekijk het mes →</em></span>
      </a>`;
    }).join("");
    return cards ? `<div class="pdp-inset"><h2 class="pdp-inset-title">Wat zit er in de set</h2><div class="pdp-inset-grid">${cards}</div></div>` : "";
  };

  // single knives: point to the set
  const upsellHTML = () => {
    if(!local.upsell || notBuyable) return "";
    const o = (window.KT_PRODUCTS || []).find(x => x.handle === local.upsell.handle);
    if(!o || o.status !== "available") return "";
    return `<a class="pdp-upsell" href="${o.url}">
      ${o.image ? `<span class="pdp-upsell-img"><img src="${o.image}" alt="${o.title}" loading="lazy" /></span>` : ""}
      <span class="pdp-upsell-body"><em>${local.upsell.title}</em><strong>${o.title} <span>${o.priceFormatted}</span></strong><span>Gyuto Koksmes en Gyuto Koksmes Tsuchime samen in één set.</span><b>Bekijk de set →</b></span>
    </a>`;
  };

  root.innerHTML = `
    <div class="pdp-carousel" id="pdp-carousel" style="--ratio:1 / 1">
      <button type="button" class="pdp-arrow pdp-arrow-prev" id="pdp-prev" aria-label="Vorige afbeelding"></button>
      <div class="pdp-slides" id="pdp-slides" tabindex="0" aria-label="Foto's van ${sp.title}">
        ${gallery.map((src, i) => `<div class="pdp-slide">${imgTag(src, i, i === 0)}</div>`).join("")}
      </div>
      <button type="button" class="pdp-arrow pdp-arrow-next" id="pdp-next" aria-label="Volgende afbeelding"></button>
      ${gallery.length > 1 ? `<div class="pdp-dots" id="pdp-dots">${gallery.map((_, i) => `<span class="pdp-dot" data-dot="${i}"></span>`).join("")}</div>` : ""}
    </div>
    <div class="pdp-gallery" style="--n:${Math.max(gallery.length, 1)}; --ratio:1 / 1">
      <div class="pdp-main" id="pdp-main">${mainMedia(0)}</div>
      <div class="pdp-thumbs">
        ${gallery.length > 1 ? gallery.map((src, i) => `<button type="button" class="pdp-thumb" aria-pressed="${i === 0}" data-thumb="${i}" aria-label="Afbeelding ${i + 1}">${imgTag(src, i, false)}</button>`).join("") : ""}
      </div>
    </div>
    <div class="pdp-info">
      <h1>${sp.title}</h1>
      ${notBuyable ? `<span class="soon-badge">${status === "soldout" ? "Uitverkocht" : "Binnenkort"}</span>` : `<div class="pdp-price"><span class="now">${sp.priceFormatted}</span>${sp.compareFormatted ? `<s>${sp.compareFormatted}</s>` : ""}${sp.saveFormatted ? `<span class="pdp-save">Je bespaart ${sp.saveFormatted}</span>` : ""}</div>`}
      <p class="pdp-desc">${local.short || ""}</p>
      ${sp.preorder && !notBuyable ? `<p class="pdp-preorder"><span class="preorder-badge">Pre-order</span> ${sp.preorderText || ""}</p>` : ""}
      ${notBuyable ? `
      <div class="pdp-soon">
        ${status === "soldout" ? `<p><strong>Tijdelijk uitverkocht.</strong> Dit mes is op dit moment niet leverbaar. Laat je e-mailadres achter, dan mailen we je zodra het weer te bestellen is.</p>` : `<p><strong>Nog niet te bestellen.</strong> Dit mes komt binnenkort beschikbaar. Laat je e-mailadres achter, dan mailen we je zodra het te bestellen is.</p>`}
        <div id="kt-notify-slot"></div>
        <div class="pdp-soon-actions">
          <a class="btn-text" href="/pages/contact">Stel een vraag</a>
          <a class="btn-text" href="/collections/all">Bekijk de messen</a>
        </div>
      </div>` : `
      <div class="pdp-buy">
        <div class="qty-stepper">
          <button type="button" aria-label="Aantal verlagen" id="qty-minus">${ICONS.minus}</button>
          <input type="text" id="qty-input" value="1" inputmode="numeric" aria-label="Aantal" />
          <button type="button" aria-label="Aantal verhogen" id="qty-plus">${ICONS.plus}</button>
        </div>
        <button type="button" class="btn btn-primary" data-add-to-cart="${sp.variantId}" data-use-qty>${sp.preorder ? "Pre-order nu" : "In winkelwagen"} <span aria-hidden="true">→</span></button>
      </div>`}
      ${notBuyable ? "" : '<div class="pdp-express" id="pdp-express-slot"></div>'}
      ${notBuyable ? "" : microHTML()}
      ${local.features ? `<ul class="checklist">${local.features.map(f => `<li>${ICONS.circleCheck}<span>${leadBold(f)}</span></li>`).join("")}</ul>` : ""}
      ${setItemsHTML()}
      ${upsellHTML()}
      ${infoAccHTML()}
    </div>`;
  root.classList.add("pdp-set");
  // "Nu kopen": adds the knife (with the chosen quantity) and goes straight to the checkout
  (function(){
    const slot = document.getElementById("pdp-express-slot");
    if(!slot) return;
    const btn = document.createElement("button");
    btn.type = "button"; btn.className = "pdp-buynow";
    btn.innerHTML = `${sp.preorder ? "Pre-order en direct afrekenen" : "Nu kopen"} <span aria-hidden="true">\u2192</span>`;
    slot.appendChild(btn);
    btn.addEventListener("click", () => {
      const q = document.getElementById("qty-input"), qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      btn.disabled = true; btn.classList.add("is-busy");
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(sp.variantId), quantity: qty }] }) })
        .then(r => r.json().then(j => ({ ok: r.ok, j })))
        .then(res => {
          if(!res.ok){ btn.disabled = false; btn.classList.remove("is-busy"); alert(res.j.description || "Toevoegen is niet gelukt."); return; }
          window.location.href = "/checkout";
        })
        .catch(() => { btn.disabled = false; btn.classList.remove("is-busy"); alert("Er ging iets mis. Probeer het opnieuw."); });
    });
  })();
  (function(){ const slot = document.getElementById("pdp-pay-slot"), t = document.getElementById("kt-pay-template"); if(slot && t && t.content.querySelector("li")) slot.appendChild(t.content.cloneNode(true)); })();

  // back-in-stock form (sold out / coming soon)
  const slot = document.getElementById("kt-notify-slot"), tpl = document.getElementById("kt-notify-template");
  if(slot && tpl){
    if(/customer_posted=true/.test(location.search)){
      slot.innerHTML = '<p class="kt-notify-done"><strong>Bedankt!</strong> We mailen je zodra dit mes beschikbaar is.</p>';
    } else {
      slot.appendChild(tpl.content.cloneNode(true));
    }
  }

  // sticky buy bar on phones: shows whenever the main buy button is out of view (below the fold or scrolled past)
  (function(){
    const buy = root.querySelector(".pdp-buy .btn");
    if(!buy || notBuyable || !("IntersectionObserver" in window)) return;
    const bar = document.createElement("div");
    bar.className = "kt-sticky-buy";
    bar.setAttribute("hidden", "");
    bar.innerHTML = `<div class="kt-sticky-info"><strong>${sp.title}</strong><span>${sp.compareFormatted ? `<s>${sp.compareFormatted}</s> ` : ""}${sp.priceFormatted}</span></div><button type="button" class="btn btn-gold kt-sticky-now">${sp.preorder ? "Pre-order nu" : "Nu kopen"} <span aria-hidden="true">→</span></button>`;
    document.body.appendChild(bar);
    const nowBtn = bar.querySelector(".kt-sticky-now");
    nowBtn.addEventListener("click", () => {
      const q = document.getElementById("qty-input"), qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      nowBtn.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: Number(sp.variantId), quantity: qty }] }) })
        .then(r => r.json().then(j => ({ ok: r.ok, j })))
        .then(res => {
          if(!res.ok){ nowBtn.disabled = false; alert(res.j.description || "Toevoegen is niet gelukt."); return; }
          window.location.href = "/checkout";
        })
        .catch(() => { nowBtn.disabled = false; alert("Er ging iets mis. Probeer het opnieuw."); });
    });
    new IntersectionObserver((entries) => {
      const e = entries[0];
      const pastIt = !e.isIntersecting;
      bar.hidden = !pastIt;
      document.body.classList.toggle("has-sticky-buy", pastIt);
    }, { threshold: 0 }).observe(buy);
  })();

  // desktop: the photos stay in view, centred, while the information next to them scrolls past
  (function(){
    const g = root.querySelector(".pdp-gallery"), hdr = document.getElementById("site-header");
    if(!g) return;
    const place = () => {
      // centred in the window, but never more than a little lower than where the photos start, so they still line up with the title at the top of the page
      const natural = root.getBoundingClientRect().top + window.scrollY;
      const top = Math.max(((hdr && hdr.offsetHeight) || 100) + 16, Math.min((window.innerHeight - g.offsetHeight) / 2, natural + 24));
      g.style.setProperty("--g-top", Math.round(top) + "px");
    };
    place();
    window.addEventListener("resize", place);
    g.querySelectorAll("img").forEach(i => i.addEventListener("load", place));
    if("ResizeObserver" in window) new ResizeObserver(place).observe(g);
  })();

  // phone gallery: swipeable slides with fade + arrows
  (function(){
    const box = document.getElementById("pdp-carousel"), slides = document.getElementById("pdp-slides");
    const prev = document.getElementById("pdp-prev"), next = document.getElementById("pdp-next");
    prev.innerHTML = ICONS.chevronL; next.innerHTML = ICONS.chevronR;
    const stepW = () => { const s = slides.querySelector(".pdp-slide"); return s ? s.getBoundingClientRect().width + parseFloat(getComputedStyle(slides).columnGap || 12) : 300; };
    const update = () => {
      const canPrev = slides.scrollLeft > 6, canNext = slides.scrollLeft < slides.scrollWidth - slides.clientWidth - 6;
      box.classList.toggle("can-prev", canPrev); box.classList.toggle("can-next", canNext);
      const i = Math.round(slides.scrollLeft / stepW());
      box.querySelectorAll(".pdp-dot").forEach((d, n) => d.classList.toggle("on", n === i));
    };
    prev.addEventListener("click", () => slides.scrollBy({ left: -stepW(), behavior: "smooth" }));
    next.addEventListener("click", () => slides.scrollBy({ left: stepW(), behavior: "smooth" }));
    slides.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    requestAnimationFrame(update);
  })();

  document.querySelectorAll("[data-thumb]").forEach(btn => btn.addEventListener("click", () => {
    document.querySelectorAll("[data-thumb]").forEach(b => b.setAttribute("aria-pressed", "false"));
    btn.setAttribute("aria-pressed", "true");
    document.getElementById("pdp-main").innerHTML = mainMedia(+btn.getAttribute("data-thumb"));
  }));

  // annotated knife
  function annoHTML(an){
    // desktop composition (1000 x 640)
    const H = 620.8, W = H * an.aspect, L = 500 - W / 2, T = 9.6;
    const pt = k => [L + an.points[k][0] * W, T + an.points[k][1] * H];
    const ends = { handle: [752, 52], heel: [702, 216], blade: [292, 306], tip: [292, 560] };
    const curve = (x, y, ex, ey) => { const dx = ex - x, dy = ey - y; return `<path d="M${x.toFixed(0)} ${y.toFixed(0)} C ${(x + dx * .4).toFixed(0)} ${(y + dy * .1).toFixed(0)}, ${(x + dx * .75).toFixed(0)} ${(y + dy * .5).toFixed(0)}, ${ex} ${ey}"/><circle cx="${x.toFixed(0)}" cy="${y.toFixed(0)}" r="4"/>`; };
    const keys = ["handle", "heel", "blade", "tip"];
    const path = k => { const [x, y] = pt(k), [ex, ey] = ends[k]; return curve(x, y, ex, ey); };

    // phone composition (500 x 760): same drawing, taller, notes in the free corners
    const mH = 730, mW = mH * an.aspect, mL = (500 - mW) / 2, mT = 15;
    const mpt = k => [mL + an.points[k][0] * mW, mT + an.points[k][1] * mH];
    const mends = { handle: [246, 70], heel: [236, 236], blade: [298, 452], tip: [298, 646] };
    const mpath = k => { const [x, y] = mpt(k), [ex, ey] = mends[k]; return curve(x, y, ex, ey); };

    return `
    <div class="anno-panel">
      <div class="anno">
        <img class="anno-knife${an.card ? " is-card" : ""}" style="left:${(L / 10).toFixed(2)}%" src="${ktAsset(an.photo)}" alt="${sp.title}, met aantekeningen" />
        <svg class="anno-lines" viewBox="0 0 1000 640" aria-hidden="true">${keys.map(path).join("")}</svg>
        <p class="note n-handle"><b>het handvat</b>${an.notes.handle}</p>
        <p class="note n-heel"><b>de hiel</b>${an.notes.heel}</p>
        <p class="note n-blade"><b>${an.bladeTitle}</b>${an.notes.blade}</p>
        <p class="note n-tip"><b>de punt</b>${an.notes.tip}</p>
      </div>
      ${an.card ? `
      <div class="anno-m anno-m-stack">
        <img class="anno-m-knife is-card" src="${ktAsset(an.photo)}" alt="${sp.title}" />
        <p class="mnote"><b>het handvat</b>${an.notes.handle}</p>
        <p class="mnote"><b>de hiel</b>${an.notes.heel}</p>
        <p class="mnote"><b>${an.bladeTitle}</b>${an.notes.blade}</p>
        <p class="mnote"><b>de punt</b>${an.notes.tip}</p>
      </div>` : `
      <div class="anno-m" role="img" aria-label="${sp.title}, met aantekeningen">
        <img class="anno-m-knife${an.card ? " is-card" : ""}" style="left:${(mL / 5).toFixed(2)}%; width:${(mW / 5).toFixed(2)}%" src="${ktAsset(an.photo)}" alt="" />
        <svg class="anno-m-lines" viewBox="0 0 500 760" aria-hidden="true">${keys.map(mpath).join("")}</svg>
        <p class="mnote m-handle"><b>het handvat</b>${an.notes.handle}</p>
        <p class="mnote m-heel"><b>de hiel</b>${an.notes.heel}</p>
        <p class="mnote m-blade"><b>${an.bladeTitle}</b>${an.notes.blade}</p>
        <p class="mnote m-tip"><b>de punt</b>${an.notes.tip}</p>
      </div>
      `}
    </div>`;
  }


  document.getElementById("pdp-story").innerHTML = `
    <div class="pdp-story-head">
      <span class="hand-eyebrow">het mes, van dichtbij</span>
      <p>${local.desc || ""}</p>
    </div>
    ${(local.anno && sp.cutout) ? annoHTML(Object.assign({}, local.anno, { photo: sp.cutout })) : (gallery.length > 1 ? `<img class="pdp-story-img" src="${gallery[gallery.length - 1]}" alt="Detail van ${sp.title}" loading="lazy" />` : "")}
    <p class="pdp-care">Zorg: was met de hand, droog direct af en zet regelmatig aan. <a href="/#zorg">Zo doe je dat</a></p>`;

  const specRows = [["Inhoud", local.includes], [/lemmet/.test(local.length || "") ? "Lemmet" : "Lengte", (local.length || "").replace(" lemmet", "")], ["Totale lengte", local.totalLength], ["Breedte", local.width], ["Breedte lemmet", local.bladeWidth], ["Dikte lemmet", local.thickness], ["Afwerking", local.finish], ["Hardheid", local.hardness], ["Gewicht", local.weight], ["Handvat", local.handle], ["Voor", local.use], ["Staal", local.steel], ["Herkomst", local.origin]].filter(r => r[1]);
  document.getElementById("pdp-specs").innerHTML = specRows.map(r => `<div><dt>${r[0]}</dt><dd>${r[1]}</dd></div>`).join("");
  const specWrap = document.getElementById("pdp-specs-wrap"); if(specWrap) specWrap.hidden = !specRows.length;
  // set: one column per knife
  if(local.specTable){
    const t = local.specTable, dash = '<span class="spec-none" aria-label="nog niet bekend">&ndash;</span>';
    document.getElementById("pdp-specs").outerHTML = `
      <div class="pdp-spec-table-wrap" id="pdp-specs">
        <table class="pdp-spec-table">
          <thead><tr><th scope="col"><span class="visually-hidden">Eigenschap</span></th>${t.cols.map(c => `<th scope="col">${c}</th>`).join("")}</tr></thead>
          <tbody>${t.rows.map(r => `<tr><th scope="row">${r[0]}</th><td>${r[1] || dash}</td><td>${r[2] || dash}</td></tr>`).join("")}</tbody>
        </table>
      </div>`;
    if(specWrap) specWrap.hidden = false;
  }

  // ---------- story blocks under the buy box ----------
  const media = sp.media || {}, copy = sp.copy || {};
  const esc = (t) => String(t == null ? "" : t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const lastPhoto = gallery.length ? gallery[gallery.length - 1] : "";

  // 1. why you will love it
  const whyEl = document.getElementById("pdp-why");
  if(whyEl && !notBuyable && media.why && (local.why || local.desc)){
    const ticks = (local.features || []).slice(0, 4).map(f => `<li>${esc(f)}</li>`).join("");
    whyEl.innerHTML = `
      <div class="container kt-why-inner">
        <div class="kt-why-copy">
          <span class="hand-eyebrow">het mes</span>
          <h2>Waarom je hem zult waarderen</h2>
          <p>${esc(local.why || local.desc)}</p>
          ${ticks ? `<ul class="kt-ticks">${ticks}</ul>` : ""}
        </div>
        <div class="kt-why-media"><img src="${media.why}" alt="${esc(sp.title)} in gebruik" loading="lazy" /></div>
      </div>`;
    whyEl.hidden = false;
  }

  // 2. the numbers: the knife itself, measured. Tap a figure and that part lights up.
  const shapeEl = document.getElementById("pdp-shape");
  const gaugeImgs = (media.gauge || []).filter(Boolean);
  if(shapeEl && !notBuyable && local.gauge && gaugeImgs.length){
    const G = local.gauge;
    G.imgs = G.knives.map(kn => gaugeImgs[kn.asset]);
    const markHTML = (k, id, m) => {
      const key = `data-k="${k}" data-m="${id}"`;
      if(m.type === "span") return `<span class="kt-g-mark kt-g-span${m.row ? " row" + m.row : ""}" ${key} style="left:${m.from * 100}%;width:${(m.to - m.from) * 100}%"><i></i><b>${esc(m.text)}</b></span>`;
      if(m.type === "bracket") return `<span class="kt-g-mark kt-g-bracket" ${key} style="left:${m.x * 100}%;top:${m.y0 * 100}%;height:${(m.y1 - m.y0) * 100}%"><i></i><b>${esc(m.text)}</b></span>`;
      if(m.type === "point") return `<span class="kt-g-mark kt-g-point" ${key} style="left:${m.x * 100}%;top:${m.y * 100}%"><i></i><b>${esc(m.text)}</b></span>`;
      if(m.type === "glow") return `<span class="kt-g-mark kt-g-glow${m.from === 0 && m.to === 1 ? " whole" : ""}" ${key} style="-webkit-mask-image:url('${G.imgs[k]}');mask-image:url('${G.imgs[k]}');clip-path:inset(0 ${(1 - m.to) * 100}% 0 ${m.from * 100}%)"></span>`;
      return "";
    };
    const turnBox = (kn, k) => {
      const T = kn.turn, I = T.inner;
      return `<div class="kt-g-box kt-g-turnbox" style="aspect-ratio:${T.ratio}">
          <canvas class="kt-g-canvas" aria-hidden="true"></canvas>
          <div class="kt-g-inner" style="left:${I.left * 100}%;top:${I.top * 100}%;width:${I.width * 100}%;height:${I.height * 100}%">
            <img src="${G.imgs[k]}" alt="${esc(kn.name || sp.title)}, van opzij" loading="lazy" />
            ${Object.entries(kn.marks || {}).map(([id, m]) => markHTML(k, id, m)).join("")}
          </div>
          <span class="kt-g-mark kt-g-point kt-g-spine-pt" data-k="${k}" data-m="${T.m}" style="left:${T.x * 100}%;top:${T.ay * 100}%"><i></i><b>${esc(T.text)}</b></span>
        </div>`;
    };
    const knives = G.knives.map((kn, k) => `
      <figure class="kt-g-knife${G.tabs && k !== 0 ? " is-off" : ""}${Object.values(kn.marks || {}).some(m => m.row === 2) ? " has-row2" : ""}">
        ${kn.name ? `<figcaption>${esc(kn.name)}</figcaption>` : ""}
        ${kn.turn ? turnBox(kn, k) : `<div class="kt-g-box" style="aspect-ratio:${G.ratios[kn.asset]}">
          <img src="${G.imgs[k]}" alt="${esc(kn.name || sp.title)}, van opzij" loading="lazy" />
          ${Object.entries(kn.marks || {}).map(([id, m]) => markHTML(k, id, m)).join("")}
        </div>`}
      </figure>`).join("");
    const stats = G.stats.map((st, i) => `
      <li data-k="${st.k}"${G.tabs && st.k !== 0 ? " hidden" : ""}><button type="button" class="kt-g-stat" data-i="${i}" aria-pressed="false">
        <span class="kt-g-l">${esc(st.l)}</span>
        <span class="kt-g-v"><b data-final="${esc(st.v)}">${esc(st.v)}</b><em>${esc(st.u)}</em></span>
      </button></li>`).join("");
    shapeEl.innerHTML = `
      <div class="container kt-g-wrap${G.tabs ? " has-tabs" : ""}">
        <div class="kt-g-head">
          <span class="hand-eyebrow">in cijfers</span>
          <h2>Precies wat je nodig hebt</h2>
        </div>
        ${G.tabs ? `<div class="kt-g-tabs" role="tablist">${G.knives.map((kn, k) => `<button type="button" role="tab" class="kt-g-tab${k === 0 ? " on" : ""}" data-k="${k}" aria-selected="${k === 0}">${esc(kn.name)}</button>`).join("")}</div>` : ""}
        <div class="kt-g-stage">${knives}</div>
        <ul class="kt-g-stats">${stats}</ul>
      </div>`;
    shapeEl.hidden = false;

    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const marks = [...shapeEl.querySelectorAll(".kt-g-mark")];
    const buttons = [...shapeEl.querySelectorAll(".kt-g-stat")];
    const isNum = (t) => /^\d+(,\d+)?$/.test(t);

    // ---- the turn: a sequence of real frames (made from the side photo to the spine photo), scrubbed forwards and backwards ----
    const turnUrl = (base, i) => (base || "").replace(/-00\.webp/, "-" + String(i).padStart(2, "0") + ".webp");
    const ease = (u) => { const s = u * u * (3 - 2 * u); return 1 - Math.pow(1 - s, 2.4); };
    shapeEl.querySelectorAll(".kt-g-knife").forEach((fig, k) => {
      const kn = G.knives[k]; const base = (media.turns && media.turns[kn.asset]) || media.turn; if(!kn.turn || !base) return;
      const T = kn.turn, box = fig.querySelector(".kt-g-box"), cv = box.querySelector(".kt-g-canvas"), ctx = cv.getContext("2d");
      const frames = [], bmps = [];
      let loaded = null;
      let p = 0, target = 0, want = 0, raf = 0, tween = null, dragging = false;
      const draw = () => {
        const n = T.count, i0 = Math.round(Math.max(0, Math.min(1, p)) * (n - 1));
        const ok = (i) => bmps[i] || (frames[i] && frames[i].complete && frames[i].naturalWidth && frames[i]);
        let a = ok(i0);
        if(!a){ for(let d = 1; d < n && !a; d++) a = ok(i0 - d) || ok(i0 + d); }
        if(!a) return;
        ctx.clearRect(0, 0, cv.width, cv.height);
        ctx.drawImage(a, 0, 0, cv.width, cv.height);          // one real frame at a time: blending two frames shows a double edge
        box.classList.toggle("at-spine", p > 0.996);
        box.classList.toggle("turning", p > 0.004 && p <= 0.996);
      };
      const size = () => { const r = box.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); cv.width = Math.max(1, Math.round(r.width * d)); cv.height = Math.max(1, Math.round(r.height * d)); draw(); };
      // every frame is fetched AND decoded up front (bitmaps), so the turn never has to decode a picture while it plays (that made it stutter on phones)
      const load = () => {
        if(loaded) return loaded;
        const jobs = [];
        for(let i = 0; i < T.count; i++){
          const im = new Image(); im.decoding = "async"; frames[i] = im;
          jobs.push(new Promise((res) => {
            im.onload = () => {
              if(i === 0){ box.classList.add("ready"); size(); }
              const done = () => { res(); if(!dragging && !tween) draw(); };
              if(window.createImageBitmap) createImageBitmap(im).then(b => { bmps[i] = b; done(); }, done); else done();
            };
            im.onerror = () => res();
          }));
          im.src = turnUrl(base, i);
        }
        loaded = Promise.all(jobs);
        return loaded;
      };
      const go = (to) => {
        target = to; cancelAnimationFrame(raf);
        if(reduce){ p = to; draw(); return; }
        const from = p, dur = 1900 * Math.max(0.3, Math.abs(to - from)), t0 = performance.now();
        tween = true;
        const step = (now) => {
          const u = Math.min(1, (now - t0) / dur);
          p = from + (to - from) * ease(u); draw();
          if(u < 1) raf = requestAnimationFrame(step); else { p = to; draw(); tween = null; }
        };
        raf = requestAnimationFrame(step);
      };
      // wait (at most 4 s) for all frames before the first turn starts; after that every turn is instant
      let waiting = 0;
      fig._turnTo = (wantSpine) => {
        want = wantSpine ? 1 : 0;
        const l = load(), run = () => { if(!dragging) go(want); };
        if(bmps.filter(Boolean).length >= T.count || !window.createImageBitmap){ run(); return; }
        const id = ++waiting;
        Promise.race([l, new Promise(r => setTimeout(r, 4000))]).then(() => { if(id === waiting){ want = want; run(); } });
      };
      // load when the knife comes near the screen, so the first turn is instant
      if("IntersectionObserver" in window) new IntersectionObserver((es, io) => { if(es[0].isIntersecting){ load(); io.disconnect(); } }, { rootMargin: "1500px" }).observe(box); else load();
      if("ResizeObserver" in window) new ResizeObserver(size).observe(box); else window.addEventListener("resize", size);
      // drag to turn the knife by hand; it eases back to where the chosen figure wants it
      if(!reduce){
        let x0 = 0, p0 = 0;
        box.addEventListener("pointerdown", (e) => { load(); cancelAnimationFrame(raf); tween = null; dragging = true; x0 = e.clientX; p0 = p; box.setPointerCapture(e.pointerId); box.classList.add("grab"); });
        box.addEventListener("pointermove", (e) => { if(!dragging) return; p = Math.max(0, Math.min(1, p0 + (e.clientX - x0) / (box.clientWidth * 0.4))); draw(); });
        const end = () => { if(!dragging) return; dragging = false; box.classList.remove("grab"); go(want); };
        box.addEventListener("pointerup", end); box.addEventListener("pointercancel", end);
      }
    });
    let played = false;
    let tab = 0;
    const inTab = (n) => !G.tabs || String(G.stats[n].k) === String(tab);
    const activate = (i) => {
      const st = i == null ? null : G.stats[i];
      marks.forEach(el => {
        const on = !!st && el.dataset.m === st.m && (st.k === "all" || String(st.k) === el.dataset.k);
        el.classList.toggle("is-on", on);
      });
      shapeEl.querySelectorAll(".kt-g-knife").forEach((fig, k) => {
        const T = G.knives[k].turn;
        if(T && fig._turnTo) fig._turnTo(!!(st && st.m === T.m && (st.k === "all" || st.k === k)));
        const mk = st && G.knives[k].marks && G.knives[k].marks[st.m];
        const whole = !!mk && mk.type === "glow" && mk.from === 0 && mk.to === 1 && (st.k === "all" || st.k === k);
        fig.classList.toggle("lit", whole);
      });
      buttons.forEach((b, n) => { b.classList.toggle("on", n === i); b.setAttribute("aria-pressed", n === i ? "true" : "false"); });
    };
    const count = (el) => {
      const fin = el.dataset.final;
      if(!isNum(fin) || reduce){ el.textContent = fin; return; }
      const dec = fin.includes(",") ? fin.split(",")[1].length : 0, target = parseFloat(fin.replace(",", ".")), t0 = performance.now(), dur = 900;
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec).replace(".", ",");
        if(p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    buttons.forEach((b, n) => {
      b.addEventListener("click", () => { if(!played) buttons.forEach(x => { const v = x.querySelector("b"); v.textContent = v.dataset.final; }); played = true; activate(n); });
      b.addEventListener("mouseenter", () => { if(played) activate(n); });
      b.addEventListener("focus", () => { if(played) activate(n); });
    });
    // the switch above the block (set page): one knife at a time, each with its own turn and its own figures
    shapeEl.querySelectorAll(".kt-g-tab").forEach(t => t.addEventListener("click", () => {
      const k = +t.dataset.k; if(k === tab) return;
      tab = k; played = true;
      shapeEl.querySelectorAll(".kt-g-tab").forEach(x => { const on = +x.dataset.k === k; x.classList.toggle("on", on); x.setAttribute("aria-selected", on); });
      shapeEl.querySelectorAll(".kt-g-knife").forEach((f, n) => f.classList.toggle("is-off", n !== k));
      shapeEl.querySelectorAll(".kt-g-stats li").forEach(li => { li.hidden = String(li.dataset.k) !== String(k); });
      buttons.forEach(x => { const v = x.querySelector("b"); v.textContent = v.dataset.final; });
      activate(buttons.findIndex((b, n) => inTab(n)));
    }));
    const play = async () => {
      for(let i = 0; i < buttons.length; i++){
        if(!inTab(i)) continue;
        if(played) return;
        activate(i);
        count(buttons[i].querySelector("b"));
        // the thickness stat turns the knife: give the turn time to finish before moving on, and time to turn back after it
        const isTurn = (n) => G.stats[n] && G.knives.some(kn => kn.turn && kn.turn.m === G.stats[n].m);
        await new Promise(r => setTimeout(r, isTurn(i) ? 3200 : (i > 0 && isTurn(i - 1) && inTab(i - 1) ? 2600 : 1100)));
      }
      played = true;
      activate(buttons.findIndex((b, n) => inTab(n)));
    };
    if(reduce || !("IntersectionObserver" in window)){
      played = true; activate(0);
    } else {
      buttons.forEach(b => { const n = b.querySelector("b"); if(isNum(n.dataset.final)) n.textContent = "0"; });
      new IntersectionObserver((entries, io) => { if(entries[0].isIntersecting){ io.disconnect(); play(); } }, { threshold: 0.35 }).observe(shapeEl.querySelector(".kt-g-stage"));
    }
  } else if(shapeEl && !notBuyable && media.loop && local.highlights && local.highlights.length){
    const stats = local.highlights.map(h => `<div><dt>${esc(h.l)}</dt><dd><span class="kt-stat-v">${esc(h.v)}</span><span class="kt-stat-u">${esc(h.u)}</span></dd></div>`).join("");
    shapeEl.innerHTML = `
      <div class="container kt-shape-inner">
        <div class="kt-shape-media">
          <video src="${media.loop}" ${(media.poster || lastPhoto) ? `poster="${media.poster || lastPhoto}"` : ""} autoplay muted loop playsinline preload="metadata" aria-label="Close-up van het lemmet"></video>
        </div>
        <div class="kt-shape-copy">
          <span class="hand-eyebrow">in cijfers</span>
          <h2>Precies wat je nodig hebt</h2>
          <dl class="kt-stats">${stats}</dl>
        </div>
      </div>`;
    shapeEl.hidden = false;
    const v = shapeEl.querySelector("video");
    if(v && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches){ v.removeAttribute("autoplay"); v.pause(); }
  }

  // 3. quality and certainty
  const trustEl = document.getElementById("pdp-trust");
  if(trustEl){
    const I = {
      shield: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
      back: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 7H5v4"/><path d="M5 11a8 8 0 1 1 2 6"/></svg>',
      lock: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="1"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
      truck: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>'
    };
    const ff = ((window.KT_CFG && window.KT_CFG.freeFrom) || 7500) / 100;
    const freeFrom = "€ " + (ff % 1 ? ff.toFixed(2).replace(".", ",") : ff);
    const items = [
      [I.shield, "10 jaar garantie", "Heb je een probleem met je mes? Neem contact met ons op."],
      [I.back, "14 dagen bedenktijd", "Ongebruikt terugsturen kan binnen 14 dagen na ontvangst."],
      [I.truck, 'Gratis verzending<span class="kt-trust-from"> vanaf ' + freeFrom + "</span>", "Bestel je voor " + freeFrom + " of meer? Dan verzenden wij je mes gratis."]
    ];
    trustEl.innerHTML = `
      <div class="container">
        <p class="kt-trust-statement">${esc(copy.trustStatement || "")}</p>
        <ul class="kt-trust-list">${items.map(i => `<li><span class="kt-trust-icon">${i[0]}</span><div><strong>${i[1]}</strong><p>${i[2]}</p></div></li>`).join("")}</ul>
      </div>`;
  }

  // 4. pairs well with: the other knives as cards
  const pairsEl = document.getElementById("pdp-pairs");
  const rank = { available: 0, soon: 1, soldout: 2 };
  const others = (window.KT_PRODUCTS || []).filter(o => o.handle !== sp.handle).sort((a, b) => rank[a.status] - rank[b.status]).slice(0, 4);
  if(pairsEl && others.length){
    pairsEl.innerHTML = `
      <div class="container">
        <div class="kt-pairs-head"><span class="hand-eyebrow">bekijk ook</span><h2>Past goed bij</h2></div>
        <div class="kt-pairs-wrap">
        <button type="button" class="kt-pairs-arrow kt-pairs-prev" aria-label="Vorige" hidden><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 5l-7 7 7 7"/></svg></button>
        <button type="button" class="kt-pairs-arrow kt-pairs-next" aria-label="Volgende" hidden><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 5l7 7-7 7"/></svg></button>
        <span class="kt-pairs-blur kt-pairs-blur-l" aria-hidden="true"></span><span class="kt-pairs-blur kt-pairs-blur-r" aria-hidden="true"></span>
        <div class="kt-pairs-grid">${others.map(o => {
          const photo = (o.image || "").trim();
          const label = o.status === "soldout" ? "Uitverkocht" : o.status === "soon" ? "Binnenkort" : "";
          return `
          <article class="kt-pair-card">
            <a class="kt-pair-media" href="${o.url}">${label ? `<span class="pc-badge">${label}</span>` : ""}${photo ? `<img src="${photo}" alt="${esc(o.title)}" loading="lazy" />` : ""}</a>
            <div class="kt-pair-body">
              <h3><a href="${o.url}">${esc(o.title)}</a></h3>
              <p class="kt-pair-price">${label ? (label === "Binnenkort" ? "Binnenkort beschikbaar" : label) : o.priceFormatted}</p>
              ${o.status === "available" ? `<button type="button" class="btn btn-ink btn-block" data-add-to-cart="${o.variantId}">In winkelwagen</button>` : `<a class="btn btn-outline btn-block" href="${o.url}">Bekijk het mes</a>`}
            </div>
          </article>`;
        }).join("")}</div>
        </div>
      </div>`;
    const wrap = pairsEl.querySelector(".kt-pairs-wrap");
    const grid = wrap.querySelector(".kt-pairs-grid");
    const update = () => {
      const max = grid.scrollWidth - grid.clientWidth;
      wrap.classList.toggle("can-prev", grid.scrollLeft > 4);
      wrap.classList.toggle("can-next", grid.scrollLeft < max - 4);
      wrap.classList.toggle("has-scroll", max > 4);
    };
    const step = dir => grid.scrollBy({ left: dir * (grid.querySelector(".kt-pair-card").offsetWidth + 12), behavior: "smooth" });
    wrap.querySelector(".kt-pairs-prev").addEventListener("click", () => step(-1));
    wrap.querySelector(".kt-pairs-next").addEventListener("click", () => step(1));
    grid.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    grid.querySelectorAll("img").forEach(i => i.addEventListener("load", update));
    update();
  }

  // 5. made with you in mind
  const careEl = document.getElementById("pdp-care");
  if(careEl && !notBuyable && media.care){
    careEl.innerHTML = `
      <div class="container kt-care-inner">
        <div class="kt-care-media"><img src="${media.care}" alt="Een mes afdrogen na het wassen" loading="lazy" /></div>
        <div class="kt-care-copy">
          <span class="hand-eyebrow">zorg</span>
          <h2>${esc(copy.careTitle || "Gemaakt met jou in gedachten")}</h2>
          <p>${esc(copy.careText || "")}</p>
          <ol class="kt-care-steps">
            <li><strong>Wassen</strong><span>met de hand, in warm water</span></li>
            <li><strong>Drogen</strong><span>direct afdrogen</span></li>
            <li><strong>Aanzetten</strong><span>regelmatig, over een slijpsteen of keramische staaf</span></li>
          </ol>
          <a class="chapter-link" href="/#zorg">Zo zorg je ervoor</a>
        </div>
      </div>`;
    careEl.hidden = false;
  }
  // 6. frequently asked questions (collapsed, same style as the information under the buy button)
  const faqEl = document.getElementById("pdp-faq");
  if(faqEl && !notBuyable){
    const I = sp.info || {};
    const qa = [
      ["Wat is een Gyuto?", "Een Gyuto is de Japanse versie van het koksmes: een lang lemmet met een licht gebogen snede, gemaakt om te wiegen en te glijden. Geschikt voor ui, vis, vlees en kruiden."],
      ["Mag het mes in de vaatwasser?", "Nee. Was het mes met de hand in warm water en droog het direct af. In de vaatwasser kan het staal roesten en het handvat beschadigen."],
      ["Hoe onderhoud ik mijn mes?", "Met drie handelingen: met de hand wassen in warm water, direct afdrogen en regelmatig aanzetten over een slijpsteen of keramische staaf."],
      ["Wat als ik niet tevreden ben?", I.returns || "Je hebt 14 dagen bedenktijd na ontvangst. Stuur het mes ongebruikt en in de originele verpakking terug."]
    ];
    faqEl.innerHTML = `
      <div class="container kt-faq-inner">
        <span class="hand-eyebrow">vragen</span>
        <h2>Veelgestelde vragen</h2>
        <div class="pdp-acc">${qa.map(x => `<details><summary>${escT(x[0])}</summary><div><p>${escT(x[1])}</p></div></details>`).join("")}</div>
      </div>`;
    faqEl.hidden = false;
  }

  // 7. knife profile: the table on the left, the drawing with the ruler on the right; both sit on the same blackboard, so there is no visible edge
  (function(){
    const wrap = document.getElementById("pdp-specs-wrap");
    if(!wrap || wrap.hidden || wrap.classList.contains("kt-profile")) return;
    const pm = (sp.media || {}).profile || [];
    const h = wrap.querySelector(".pdp-specs-title");
    const left = document.createElement("div"), eyebrow = document.createElement("span");
    left.className = "kt-profile-text";
    eyebrow.className = "kt-profile-eyebrow"; eyebrow.textContent = "Mesprofiel";
    left.appendChild(eyebrow);
    if(h) left.appendChild(h);
    [...wrap.children].forEach(c => { if(c !== left && c !== h) left.appendChild(c); });
    wrap.appendChild(left);
    if(pm[1]){
      const fig = document.createElement("figure");
      fig.className = "kt-profile-fig";
      fig.innerHTML = `<img src="${pm[1]}" alt="${escT(sp.title)} met de maten: 33 cm in totaal, 21 cm lemmet, 12 cm handvat en 4,8 cm breed" loading="lazy" decoding="async" />`;
      wrap.appendChild(fig);
      wrap.classList.add("has-fig");
    }
    wrap.classList.add("kt-profile");
    const sec = document.getElementById("pdp-specs-sec");
    if(sec){ sec.classList.add("is-profile"); if(pm[0]) sec.style.backgroundImage = `linear-gradient(rgba(14,12,11,.35), rgba(14,12,11,.35)), url('${pm[0]}')`; }
  })();
})();
